/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Spin, notification } from "antd";
import SVG from "react-inlinesvg";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import * as auth from "../../../Auth";
import { changePassword, generateResetPassword } from "../../_redux/users/usersCrud";
import * as actions from "../../_redux/users/usersActions";
import { Notification } from "../../../../modules//Common/partials/Notification";
import { ForgotPasswordModal } from "./ForgotPasswordModal";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

function ResetPasswordPage(props) {
  const [passwordEyeIconNew, setPasswordEyeIconNew] = useState("password");
  const [passwordEyeIconVerify, setPasswordEyeIconVerify] = useState("password");
  const longText = `
  Password must contain 8 characters. uppercase, lowercase, number and symbol.
  `;
  // Fields
  const [loading, setLoading] = useState(false);
  const [isError, setisError] = useState(false);
  const history = useHistory();
  // Methods

  // UI Helpers
  const initialValues = {
    password: "",
    cPassword: "",
  };
  const Schema = Yup.object().shape({
    password: Yup.string().required("New Password is required"),
    cPassword: Yup.string()
      .required("Password confirmation is required")
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf([Yup.ref("password")], "Password and Confirm Password didn't match"),
      }),
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: (values, resetForm) => {
      passwordReset(values);
    },
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });

  const passwordReset = async (values) => {
    setLoading(true);
    try {
      const response = await generateResetPassword({
        password: values.password,
        reset_key: window.location.pathname.split("/")[window.location.pathname.split("/").length - 1],
      });
      notification.success({ message: response.data.message, duration: 5 });
      history.push(`/users/profile`);
    } catch (err) {
      err.response.data.errors.map((error) => notification.error({ message: error, duration: 5 }));
    } finally {
      setLoading(false);
    }
  };
  const setPasswordTypeNew = (type) => {
    if (type == "text") setPasswordEyeIconNew("password");
    if (type == "password") {
      setPasswordEyeIconNew("text");
    }
  };

  const setPasswordTypeVerify = (type) => {
    if (type == "text") setPasswordEyeIconVerify("password");
    if (type == "password") {
      setPasswordEyeIconVerify("text");
    }
  };

  return (
    <>
      <Spin spinning={loading}>
        <form className="card card-custom" onSubmit={formik.handleSubmit}>
          {/* begin::Header */}
          <div className="card-header py-3">
            <div className="card-title align-items-start flex-column">
              <h3 className="card-label font-weight-bolder text-dark">Reset Password</h3>
              <span className="text-muted font-weight-bold font-size-sm mt-1">Change your account password</span>
            </div>
            <div className="card-toolbar">
              <button
                type="submit"
                className="btn btn-success mr-2"
                // disabled={formik.isSubmitting || (formik.touched && !formik.isValid)}
                // onClick={() => console.log(formik.isValid)}
              >
                Reset Password
                {formik.isSubmitting}
              </button>
              <Link to="/users/profile/personal-information" className="btn btn-secondary">
                Cancel
              </Link>
            </div>
          </div>
          {/* end::Header */}
          {/* begin::Form */}
          <div className="form">
            <div className="card-body">
              {/* begin::Alert */}
              {isError && (
                <div className="alert alert-custom alert-light-danger fade show mb-10" role="alert">
                  <div className="alert-icon">
                    <span className="svg-icon svg-icon-3x svg-icon-danger">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}></SVG>{" "}
                    </span>
                  </div>
                  <div className="alert-text font-weight-bold">
                    Configure user passwords to expire periodically. Users will need warning that their passwords are going to expire,
                    <br />
                    or they might inadvertently get locked out of the system!
                  </div>
                  <div className="alert-close" onClick={() => setisError(false)}>
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">
                        <i className="ki ki-close"></i>
                      </span>
                    </button>
                  </div>
                </div>
              )}
              {/* end::Alert */}

              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label text-alert">New Password</label>
                <div className="col-lg-9 col-xl-6">
                  <Tooltip
                    title={<p style={{ color: "black" }}>{longText}</p>}
                    color={"#F0F0F0"}
                    key={"#F0F0F0"}
                    overlayStyle={{ maxWidth: "350px" }}
                    placement="topLeft"
                  >
                    <div className="d-flex">
                      <input
                        type={passwordEyeIconNew}
                        placeholder="New Password"
                        className={`form-control form-control-lg form-control-solid ${getInputClasses("password")}`}
                        name="password"
                        {...formik.getFieldProps("password")}
                      />
                      {passwordEyeIconNew == "password" ? (
                        <EyeInvisibleOutlined
                          onClick={() => {
                            setPasswordTypeNew(passwordEyeIconNew);
                          }}
                          style={{
                            cursor: "pointer",
                            color: "#8d9190",
                            marginLeft: "-60px",
                            marginTop: "13px",
                            fontSize: "20px",
                          }}
                        />
                      ) : (
                        <EyeOutlined
                          onClick={() => {
                            setPasswordTypeNew(passwordEyeIconNew);
                          }}
                          style={{
                            cursor: "pointer",
                            color: "#8d9190",
                            marginLeft: "-60px",
                            marginTop: "13px",
                            fontSize: "20px",
                          }}
                        />
                      )}
                    </div>
                  </Tooltip>
                  {formik.touched.password && formik.errors.password ? <div className="invalid-feedback">{formik.errors.password}</div> : null}
                </div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label text-alert">Verify Password</label>
                <div className="col-lg-9 col-xl-6">
                  {/* <Tooltip
                    title={<p style={{ color: "black" }}>{longText}</p>}
                    color={"#F0F0F0"}
                    key={"#F0F0F0"}
                    overlayStyle={{ maxWidth: "350px" }}
                    placement="topLeft"
                  > */}
                  <div className="d-flex">
                    <input
                      type={passwordEyeIconVerify}
                      placeholder="Verify Password"
                      className={`form-control form-control-lg form-control-solid ${getInputClasses("cPassword")}`}
                      name="cPassword"
                      {...formik.getFieldProps("cPassword")}
                    />
                    {passwordEyeIconVerify == "password" ? (
                      <EyeInvisibleOutlined
                        onClick={() => {
                          setPasswordTypeVerify(passwordEyeIconVerify);
                        }}
                        style={{
                          cursor: "pointer",
                          color: "#8d9190",
                          marginLeft: "-60px",
                          marginTop: "13px",
                          fontSize: "20px",
                        }}
                      />
                    ) : (
                      <EyeOutlined
                        onClick={() => {
                          setPasswordTypeVerify(passwordEyeIconVerify);
                        }}
                        style={{
                          cursor: "pointer",
                          color: "#8d9190",
                          marginLeft: "-60px",
                          marginTop: "13px",
                          fontSize: "20px",
                        }}
                      />
                    )}
                  </div>
                  {/* </Tooltip> */}
                  {formik.touched.cPassword && formik.errors.cPassword ? <div className="invalid-feedback">{formik.errors.cPassword}</div> : null}
                </div>
              </div>
            </div>
          </div>
          {/* end::Form */}
        </form>
      </Spin>
    </>
  );
}

export default connect(null, auth.actions)(ResetPasswordPage);
